import UpdateRequired from 'components/organisms/students/modal_contents/update_requied/UpdateRequired';
import { connect } from 'react-redux';
const mapStateToProps = (state, props) => {
    return {};
};
const enhancer = connect(mapStateToProps, {});
export default enhancer(UpdateRequired);
